export var CampaignUpdateType;
(function (CampaignUpdateType) {
    CampaignUpdateType["Image"] = "image";
    CampaignUpdateType["Text"] = "text";
    CampaignUpdateType["Video"] = "video";
})(CampaignUpdateType || (CampaignUpdateType = {}));
